import {computed} from 'vue'
import {usePage} from '@inertiajs/inertia-vue3'

export default () => {
    return computed(() => {
        return usePage().props.value.auth.user
    })
}